import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { IuniFlower } from "@/components/landing/IuniFlower";

const SECTIONS = [
  {
    title: "1. Titolare del Trattamento",
    body: [
      "Il Titolare del trattamento dei dati personali è iuni — Logistica & Finanza Nuziale (di seguito, “il Titolare”). I dati societari completi e la sede legale saranno pubblicati in questa pagina al lancio ufficiale della piattaforma.",
      "Per qualsiasi richiesta relativa alla privacy puoi contattarci tramite i canali indicati nella sezione “Diritti dell'interessato”.",
    ],
  },
  {
    title: "2. Dati che raccogliamo",
    body: [
      "Attraverso il modulo di iscrizione alla lista d'attesa raccogliamo esclusivamente: i nomi della coppia, l'indirizzo email, la data prevista del matrimonio (facoltativa) e la tua principale area di interesse o preoccupazione organizzativa (facoltativa).",
      "Non raccogliamo dati sensibili, dati di pagamento né documenti di identità in questa fase.",
    ],
  },
  {
    title: "3. Finalità e base giuridica",
    body: [
      "I dati vengono trattati per: (a) gestire la tua iscrizione alla lista d'attesa del programma Beta di iuni; (b) inviarti comunicazioni relative all'apertura del tuo accesso; (c) analisi aggregate e anonime per migliorare il servizio.",
      "La base giuridica del trattamento è il tuo consenso esplicito (art. 6, par. 1, lett. a del GDPR), espresso tramite la casella di accettazione presente nel modulo.",
    ],
  },
  {
    title: "4. Conservazione dei dati",
    body: [
      "Conserviamo i tuoi dati per un massimo di 12 mesi dall'iscrizione alla lista d'attesa, o fino alla revoca del consenso, se precedente. Al termine del periodo, i dati vengono cancellati in modo definitivo.",
    ],
  },
  {
    title: "5. Condivisione e sicurezza",
    body: [
      "I tuoi dati non vengono venduti né ceduti a terzi per finalità di marketing. Possono essere trattati da fornitori tecnici che operano per nostro conto (hosting, invio di email transazionali) nel rispetto del GDPR e di adeguati accordi di trattamento.",
      "Adottiamo misure tecniche e organizzative appropriate per proteggere i dati da accessi non autorizzati, perdita o divulgazione.",
    ],
  },
  {
    title: "6. Diritti dell'interessato",
    body: [
      "In qualità di interessato, ai sensi degli artt. 15–22 del GDPR, hai diritto di: accedere ai tuoi dati, chiederne la rettifica o la cancellazione, limitare o opporti al trattamento, richiedere la portabilità dei dati e revocare il consenso in qualsiasi momento senza pregiudicare la liceità del trattamento precedente.",
      "Per esercitare i tuoi diritti scrivi a: [email privacy — in attivazione al lancio della Beta]. Hai inoltre diritto di proporre reclamo al Garante per la protezione dei dati personali (www.garanteprivacy.it).",
    ],
  },
  {
    title: "7. Cookie",
    body: [
      "Questa pagina non utilizza cookie di profilazione né strumenti di tracciamento di terze parti. Possono essere presenti esclusivamente cookie tecnici strettamente necessari al funzionamento del sito.",
    ],
  },
  {
    title: "8. Modifiche a questa informativa",
    body: [
      "Il Titolare può aggiornare la presente informativa in qualsiasi momento. La versione vigente è quella pubblicata su questa pagina, con indicazione della data di ultimo aggiornamento.",
    ],
  },
];

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-white text-[#1A1A1A]" data-testid="privacy-policy-page">
      <header className="sticky top-0 z-40 bg-white/80 backdrop-blur-xl border-b border-gray-200/50">
        <div className="max-w-4xl mx-auto px-6 h-20 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5" data-testid="privacy-logo-link">
            <IuniFlower size={26} />
            <span className="text-xl font-bold tracking-tight text-[#2D2926]">iuni</span>
          </Link>
          <Link
            to="/"
            data-testid="privacy-back-home-link"
            className="inline-flex items-center gap-2 text-sm font-medium text-gray-500 hover:text-[#C2492F] transition-colors"
          >
            <ArrowLeft size={15} />
            Torna alla Home
          </Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 py-20 sm:py-28">
        <p className="text-[11px] font-bold uppercase tracking-[0.22em] text-[#C2492F]">
          Documento legale
        </p>
        <h1 className="font-display text-4xl sm:text-5xl tracking-tight mt-4">Privacy Policy</h1>
        <p className="text-sm text-gray-400 mt-4">
          Ultimo aggiornamento: ottobre 2026 · Informativa ai sensi dell'art. 13 del Regolamento (UE)
          2016/679 (“GDPR”)
        </p>

        <div className="mt-14 space-y-12">
          {SECTIONS.map((s) => (
            <section key={s.title}>
              <h2 className="font-display text-2xl text-[#1A1A1A]">{s.title}</h2>
              {s.body.map((p, i) => (
                <p key={i} className="text-base text-gray-500 leading-relaxed mt-4">
                  {p}
                </p>
              ))}
            </section>
          ))}
        </div>
      </main>

      <footer className="border-t border-gray-100 py-10">
        <div className="max-w-4xl mx-auto px-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-gray-400">© 2026 iuni. Tutti i diritti riservati.</p>
          <Link
            to="/"
            className="text-sm text-gray-400 hover:text-[#C2492F] transition-colors"
          >
            Torna alla Home
          </Link>
        </div>
      </footer>
    </div>
  );
}
